import { render, staticRenderFns } from "./Tutoring.vue?vue&type=template&id=e645c0dc&scoped=true"
import script from "./Tutoring.vue?vue&type=script&lang=js"
export * from "./Tutoring.vue?vue&type=script&lang=js"
import style0 from "./Tutoring.vue?vue&type=style&index=0&id=e645c0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e645c0dc",
  null
  
)

export default component.exports